
<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <!--<div class="w-full mt-4">
          Transporter
          <div class="vx-row">
            <div class="vx-col w-2/3">
              <v-select autocomplete :options="data_option_people_name" v-model="dataIdPeople" />
            </div>
            <div class="vx-col w-1/3">
            <vs-button class="ml-auto" color="#333b34" @click="record_data_go_to_add_person()">Add</vs-button>
            </div>
          </div>
        </div>-->
        <vs-alert v-if="quotationid">
          <div> Organizing transport for quotation #{{ quotationid }} ({{ quotationclient }})</div>
        </vs-alert>

        <p class="w-full mt-4"> Transport Date
          <datepicker :inline="false" v-model="dataDate"></datepicker>
        </p>
      </div>
      <div class="vx-col md:w-1/2 w-full">
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button v-if="quotationid" class="ml-8" color="success" @click="save_changes_with_quotation_id()"
            :disabled="!validateForm">Next Step</vs-button>
          <vs-button v-else class="ml-8" color="success" @click="save_changes()" :disabled="!validateForm">Next
            Step</vs-button>
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import moduleOperationList from '@/store/operation/moduleOperationList.js'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import axios from '@/axios.js'
import moment from 'moment'

export default {
  components: {
    vSelect,
    Datepicker
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isMounted: false,
      // Data Sidebar
      buttonSubmitOpen: false,
      state: {},
      dataDate: '',
      dataOperationCategory: '7',
      dataIdPeople: '',
      data_option_people_name: [],
      quotationid: null,
      quotationclient: null,
      dataAvizSerie: null,
      dataAvizNumber: null,
    }

  },
  computed: {
    validateForm() {
      return !this.errors.any() && (this.dataDate && this.dataOperationCategory/* && this.dataIdPeople*/)
    },
    currentPage() {
      if (this.isMounted) {
        if (this.data_local.id) return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      if (this.data_local.id) return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length
    }
  },
  methods: {
    async getLastNrFromSerie(serie) {
      const response = await axios.get("/transport/getlastnrfromserie/" + serie)
      const last = response.data.last || 1
      this.dataAvizNumber = last
      return last
    },
    record_data_go_to_add_person() {
      localStorage.setItem('creating-operation-and-need-to-add-user', true)
      localStorage.setItem('creating-operation-and-need-to-add-user-category', this.dataOperationCategory)
      localStorage.setItem('creating-operation-and-need-to-add-user-date', this.dataDate)
      localStorage.setItem('creating-operation-and-need-to-add-user-page-source', 'transport-add')
      this.$router.push('/person-add').catch(() => { })
    },
    async getPeople() {
      axios.get('/people_name/data')
        .then((response) => {
          this.data_option_people_name = [...response.data]
          this.setDataFromNewPerson()
        })
    },
    async setDataFromNewPerson() {
      if (localStorage.getItem('creating-operation-and-need-to-add-user')) {
        this.dataOperationCategory = localStorage.getItem('creating-operation-and-need-to-add-user-category');
        this.dataDate = localStorage.getItem('creating-operation-and-need-to-add-user-date');
        setTimeout(() => {
          const storedValue = Number(localStorage.getItem('creating-operation-and-need-to-add-user-person'));
          console.log("Valeur stockée :", storedValue);
          console.log("Liste des personnes :", this.data_option_people_name);

          if (!storedValue) {
            console.warn("⚠️ Aucune valeur trouvée dans localStorage !");
          } else {
            console.log("🔍 Recherche de l'élément correspondant...");
            this.dataIdPeople = this.data_option_people_name.find((p) => p.value.valueOf() === storedValue);

            console.log("🔹 Résultat de find() :", this.dataIdPeople);

            if (!this.dataIdPeople) {
              console.warn(`⚠️ Aucun élément trouvé avec la valeur '${storedValue}' dans data_option_people_name`);
            } else {
              console.log("✅ Élément trouvé :", this.dataIdPeople);
            }
          }
        }, 1000);
      }

      localStorage.removeItem('creating-operation-and-need-to-add-user');
      localStorage.removeItem('creating-operation-and-need-to-add-user-category');
      localStorage.removeItem('creating-operation-and-need-to-add-user-date');
      localStorage.removeItem('creating-operation-and-need-to-add-user-page-source');
    },
    async save_changes_with_quotation_id() {
      this.$vs.loading()
      try {
        this.dataAvizSerie = moment(this.dataDate).format("YYYY")
        this.dataAvizNumber = await this.getLastNrFromSerie(this.dataAvizSerie)

        let personId = null
        if (this.dataIdPeople) {
          if (this.dataIdPeople.value) personId = this.dataIdPeople.value
          else personId = this.dataIdPeople[0].value
        }
        const obj = {
          date: moment(this.dataDate).add(12, 'hours').format('YYYY-MM-DD hh:mm:ss+02'),
          operationcategory: this.dataOperationCategory,
          idperson: personId,
          transport_entrant: false,
          isactive: true,
        }

        await this.$store.dispatch('operationList/createTransport', obj)
        const transportId = this.$store.state.operationList.operation.id

        const obj1 = {
          idtransport: transportId,
          idinvoice: this.quotationid,
          aviz_serie: this.dataAvizSerie,
          aviz_number: this.dataAvizNumber,
          unloadingorder: 1,
          delete: false,
        }
        await this.$store.dispatch("operationList/linkOperationToTransportFromAdd", obj1)

        localStorage.removeItem('organize-transport-for-quotation-id')
        localStorage.removeItem('organize-transport-for-quotation-client')

        this.$vs.loading.close()
        this.$vs.notify({
          color: 'success',
          title: 'Transport Linked',
          text: 'The selected Quotation/Purchase order was successfully linked',
        })
        this.$router.push({ path: '/transport-edit/' + transportId })
      } catch (err) {
        console.error(err)
        this.$vs.loading.close()
        this.$vs.notify({
          color: 'alert',
          title: 'An Error Occured!',
          text: 'The operation was NOT added, please contact your dev',
        })
      }
    },
    save_changes() {
      this.$vs.loading()
      let personId = null
      if (this.dataIdPeople) {
        if (this.dataIdPeople.value) personId = this.dataIdPeople.value
        else personId = this.dataIdPeople[0].value
      }
      const obj = {
        date: moment(this.dataDate).add(12, 'hours').format('YYYY-MM-DD hh:mm:ss+02'),
        operationcategory: this.dataOperationCategory,
        idperson: personId,
        transport_entrant: false,
        isactive: true
      }
      {
        this.$store.dispatch('operationList/createTransport', obj)
          .then(response => {
            this.$vs.loading.close()
            this.$vs.notify({
              color: 'success',
              title: '',
              text: 'Operation Correctly Started!'
            })
            this.$router.push({ path: '/transport-edit/' + this.$store.state.operationList.operation.id })
          }
          )
          .catch(err => {
            this.$vs.loading.close()
            this.$vs.notify({
              color: 'alert',
              title: 'An Error Occured!',
              text: 'The operation was NOT added, please contact your dev'
            })
          })
      }
    }
  },
  mounted() {
    this.isMounted = true
  },
  created() {
    this.getPeople()
    this.dataDate = moment().format("D MMM yyyy");
    this.quotationid = localStorage.getItem('organize-transport-for-quotation-id')
    this.quotationclient = localStorage.getItem('organize-transport-for-quotation-client')
    localStorage.removeItem('organize-transport-for-quotation-id')
    localStorage.removeItem('organize-transport-for-quotation-client')
  }
}
</script>

